export default __webpack_public_path__ + "static/media/pest_control.cbbf875c.svg";